// utils/filterRoutesByAccess.js
import { config } from './config';

function filterRoutesByAccess(clientAccess) {
    const { routes, routeMapping } = config;

    // Filter the client access array to include only enabled items
    const filteredAccessArray = clientAccess?.filter((item) => item.enabled);

    // Filter routes based on whether their corresponding access_desc is enabled
    const filteredRoutes = routes?.filter((route) => {
        const accessDesc = routeMapping[route];
        return filteredAccessArray?.some((item) => item.access_desc === accessDesc);
    });

    // Return both the filtered access array and filtered routes
    return { filteredAccessArray, filteredRoutes };
}

export default filterRoutesByAccess;
